import React from "react";
import { useSelector } from "react-redux";

import { ContentBox, ContentBoxIcon } from "../../components";
import * as commonStyles from "../../components/commonStyles/commonStyles.module.css";
import { useStrings } from "../../localization/localizationHelpers";
import { CrmGameConceptStatus, CrmGameConceptSubStatus } from "../../models/crmStatus";
import { TokenAndStudioIds } from "../../pages/IdXboxWelcomePartnerPage/WelcomePartnerSection/TokenAndStudioIds";
import { getGameConceptsList, getPartnerCenterToken } from "../../redux/selectors";
import { FormattedText } from "../FormattedText";
import * as styles from "./PartnerCenterTokenInfoBox.module.css";

export const PartnerCenterTokenInfoBox = () => {
  const [partnerCenterSoftTokenInfoBoxTitle, partnerCenterSoftTokenInfoBoxContent] = useStrings(
    "partnerCenterSoftTokenInfoBoxTitle",
    "partnerCenterSoftTokenInfoBoxContent"
  );
  const partnerCenterToken = useSelector(getPartnerCenterToken);
  const gameConceptsList = useSelector(getGameConceptsList);

  if (!partnerCenterToken || !gameConceptsList) {
    return null;
  }

  let isAtLeastOneRejectedNeedDevTokenGameConcept = false;
  let isAtLeastOneApprovedGameConcept = false;
  for (const gameConceptKey of Object.keys(gameConceptsList)) {
    const concept = gameConceptsList[gameConceptKey];
    const conceptStatus = concept?.state?.status;
    const conceptSubStatus = concept?.state?.subStatus;

    if (
      conceptStatus === CrmGameConceptStatus.Rejected &&
      conceptSubStatus === CrmGameConceptSubStatus.RejectedSoftNeedsDevToken
    ) {
      isAtLeastOneRejectedNeedDevTokenGameConcept = true;
    }

    if (
      conceptStatus === CrmGameConceptStatus.AdditionalContractsSent ||
      conceptStatus === CrmGameConceptStatus.Accepted
    ) {
      isAtLeastOneApprovedGameConcept = true;
    }
  }

  if (!isAtLeastOneRejectedNeedDevTokenGameConcept || isAtLeastOneApprovedGameConcept) {
    return null;
  }

  return (
    <ContentBox
      titleConfiguration={{
        title: partnerCenterSoftTokenInfoBoxTitle,
        icon: ContentBoxIcon.CheckMark,
      }}
    >
      <div className={commonStyles.rowContainer}>
        <div>
          <FormattedText
            text={partnerCenterSoftTokenInfoBoxContent}
            className={styles.description}
          />
          <TokenAndStudioIds />
        </div>
      </div>
    </ContentBox>
  );
};
